import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import { QRContainer, QRCanvas, QRInfo } from './QRDisplay.styles';

const QRDisplay = ({ value, size = 200, reservationId }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (value && canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, value, {
        width: size,
        margin: 2,
        // Negro sobre blanco a propósito: máxima legibilidad para el lector de QR (no es color de marca).
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      });
    }
  }, [value, size]);

  const handleDownload = () => {
    if (canvasRef.current) {
      const link = document.createElement('a');
      link.download = `QR-${reservationId || 'code'}.png`;
      link.href = canvasRef.current.toDataURL();
      link.click();
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    alert('Código QR copiado al portapapeles');
  };

  return (
    <QRContainer>
      <QRCanvas 
        ref={canvasRef} 
        width={size} 
        height={size}
      />
      <QRInfo>
        <p>ID: {reservationId}</p>
        <div className="qr-actions">
          <button onClick={handleDownload}>
            ⬇️ Descargar
          </button>
          <button onClick={handleCopy}>
            📋 Copiar Código
          </button>
        </div>
      </QRInfo>
    </QRContainer>
  );
};

export default QRDisplay;